import { FormControlLabel, Switch } from "@mui/material";
import { DeferredSearchField } from "design-components";

export interface OperatorsToolbarProps {
  searchValue: string;
  showOnlyActive: boolean;
  onSearchTrigger: (value: string) => void;
  onShowOnlyActiveChange: (value: boolean) => void;
  onFilterClick: () => void;
}

export function OperatorsToolbar(props: OperatorsToolbarProps) {
  const {
    searchValue,
    showOnlyActive,
    onSearchTrigger,
    onShowOnlyActiveChange,
    onFilterClick,
  } = props;

  return (
    <div className="users-toolbar operators-toolbar">
      <div className="users-toolbar__actions--no-actions" aria-hidden />
      <div className="users-toolbar__admin-secondary-wrap operators-toolbar__secondary-wrap">
        <FormControlLabel
          className="users-toolbar__toggle-label--aviro-active operators-toolbar__toggle-label"
          control={
            <Switch
              checked={showOnlyActive}
              onChange={(_, checked) => onShowOnlyActiveChange(checked)}
              inputProps={{ "aria-label": "Show only active operators" }}
              className="toggle"
            />
          }
          label="Show only active"
        />
      </div>
      <div className="users-toolbar__search-wrap operators-toolbar__search-wrap">
        <DeferredSearchField
          className="users-toolbar__search-field"
          placeholder="Search..."
          searchValue={searchValue}
          onSearchTrigger={onSearchTrigger}
          onFilterClick={onFilterClick}
          fullWidth
          size="small"
        />
      </div>
    </div>
  );
}
